module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index requests-wrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Заявки на обслуживание",
      "name": "first"
    }
  }, [_c('div', {
    staticClass: "requests"
  }, [_c('div', {
    staticClass: "tr columns"
  }, [_c('span', {
    staticClass: "empty"
  }), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Имя")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("ИНН")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Прикрепленный документ")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Статус клиента")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Дата заявки")])]), _vm._v(" "), _vm._l((_vm.requestsObject), function(request) {
    return _c('RequestItem', {
      key: request.id,
      attrs: {
        "request": request
      }
    })
  })], 2)]), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "consultation-requests",
    attrs: {
      "label": "Заявки на консультацию"
    }
  }, [_c('div', {
    staticClass: "tr columns"
  }, [_c('span', {
    staticClass: "empty"
  }), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Имя")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Время консультации")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Статус клиента")]), _vm._v(" "), _c('span', {
    staticClass: "column"
  }, [_vm._v("Дата заявки")])]), _vm._v(" "), _vm._l((_vm.consultationRequestsObject), function(request) {
    return _c('ConsultationRequestItem', {
      key: request.id,
      attrs: {
        "request": request
      }
    })
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c75eb82c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceRequests/Index.vue
// module id = 1000
// module chunks = 0